import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const ArrowLeftCircled = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <g transform="translate(0, -0.88)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.33275 8.27672C4.88908 8.58065 4.88908 9.16936 5.33275 9.47336L8.60129 11.7127C9.16971 12.1021 10 11.7469 10 11.1144L10 6.63565C10 6.00311 9.16971 5.64793 8.60129 6.03733L5.33275 8.27672Z"
          fill={COLORS.neutral.darkGray}
        />
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="7.5"
        stroke={COLORS.neutral.darkGray}
      />
    </SvgIcon>
  ))
);
